module.exports = __webpack_public_path__ + "img/credit-standard.0cfde09f.png";